import {
    Button,
    Grid,
    InputAdornment,
    TextField,
    TextFieldProps,
    Typography,
} from '@deltasierra/react-components-core';
import { SearchSm, XClose } from '@deltasierra/react-icons';
import { theme } from '@deltasierra/react-theme';

export type AssetLibrarySearchInputProps = {
    ariaLabel?: string;
    disabled: boolean;
    onChange: TextFieldProps['onChange'];
    onClickClearSearch: () => void;
    onClickSearchButton: () => void;
    placeholder?: string;
    searchButtonText: string;
    value: string;
};

export function AssetLibrarySearchInput({
    ariaLabel,
    disabled,
    onChange,
    onClickClearSearch,
    onClickSearchButton,
    placeholder,
    searchButtonText,
    value,
}: AssetLibrarySearchInputProps): JSX.Element {
    return (
        <Grid container size="grow" spacing={1.2}>
            <Grid size="grow">
                <TextField
                    data-cy="asset-library-search-input"
                    disabled={disabled}
                    fullWidth
                    placeholder={placeholder}
                    slotProps={{
                        htmlInput: {
                            'aria-label': ariaLabel,
                        },
                        input: {
                            endAdornment: value ? (
                                <InputAdornment position="end">
                                    <Button
                                        aria-label={ariaLabel}
                                        data-cy="asset-library-clear-search-button"
                                        size="medium"
                                        sx={{ height: '56px' }}
                                        variant="text"
                                        onClick={onClickClearSearch}
                                    >
                                        <XClose color={theme.palette.primary.main} />
                                    </Button>
                                </InputAdornment>
                            ) : undefined,
                            startAdornment: (
                                <InputAdornment position="start">
                                    <SearchSm color={theme.palette.primary.main} />
                                </InputAdornment>
                            ),
                            sx: { paddingRight: value ? 0 : 2 },
                        },
                    }}
                    sx={{
                        fieldset: { transition: 'border-color 0.2s ease-in-out' },
                        marginRight: 1.2,
                    }}
                    value={value}
                    onChange={onChange}
                    onKeyDown={event => event.key === 'Enter' && onClickSearchButton()}
                />
            </Grid>
            <Grid size="auto">
                <Button
                    data-cy="asset-library-search-button"
                    size="medium"
                    sx={{ height: '56px' }}
                    variant="contained"
                    onClick={onClickSearchButton}
                >
                    <Typography>{searchButtonText}</Typography>
                </Button>
            </Grid>
        </Grid>
    );
}

AssetLibrarySearchInput.displayName = 'AssetLibrarySearchInput';
